import axiosClient from "./axiosClient";

export const dashboardApi = {
  couponCount: (params: { type: string }) => {
    const url = "/dashboard/patient-coupon-count-info";
    return axiosClient.get(url, { params });
  },
  couponInfo: (params: { region: string }) => {
    const url = "/dashboard/coupon-info-graph";
    return axiosClient.get(url, { params });
  },
  clientAgeInfo: () => {
    const url = "/dashboard/client-info-age-group";
    return axiosClient.get(url);
  },
  clinicGraph: (params: { region: string }) => {
    const url = "/dashboard/clinic-count-graph";
    return axiosClient.get(url, { params });
  },
  clinicHcpCount: () => {
    const url = "/dashboard/clinic-hcp-count";
    return axiosClient.get(url);
  },
};
